import api from '..';

export const getKytRulesRequest = () => {
  return api.get('/kyt/rules');
};

export const updateKytRuleRequest = (payload) => {
  const { id, ...data } = payload;
  return api.patch(`/kyt/rules/${id}`, data);
};
